import { Card, Heading, Text, VStack } from "@chakra-ui/react";
import { ComponentProps } from "react";

type PPBannerProps = {
  appName: string;
} & ComponentProps<typeof Card.Root>;

export const PPBanner = ({ appName, ...props }: PPBannerProps) => {
  return (
    <Card.Root
      borderRadius="2xl"
      backgroundImage="url(/assets/apps/modal/pp-banner.avif)"
      backgroundRepeat="no-repeat"
      backgroundSize="contain"
      px={6}
      h={128}
      border="none"
      w="full"
      py={4}
      {...props}
    >
      <Card.Body p={0}>
        <VStack align="start" gap={1} h="full" justifyContent="center">
          <Heading size="lg" fontWeight="500">
            Plume Points
          </Heading>
          <Text fontSize="md" color="fg.muted">
            Earn PP by using {appName}
          </Text>
        </VStack>
      </Card.Body>
    </Card.Root>
  );
};
